/**
 * @flow
 */

// eslint-disable-next-line i18next/no-literal-string
export const apiBase = "/api/v1/";
